import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      width: '500px !important',
      '& > div:first-child': {
        padding: '4px 10px !important',
      },
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  button: { backgroundColor: '#444', width: '150px', height: '50px', fontSize: '18px' }
}));
export default styles;
